<template>
    <div
        class="trustpilot-reviews-summary trustpilot-clearfix trustpilot-reviews-category"
    >
        <div
            class="trustpilot-star-rating trustpilot-size-small trustpilot-clearfix"
            :class="`trustpilot-count-${stars}`"
        >
            <a
                :href="linkToProduct"
                @click="$emit('click')"
                class="trustpilot-star-rating trustpilot-size-small trustpilot-clearfix"
                :class="`trustpilot-count-${stars}`"
            >
                <div class="trustpilot-star-1">
                    <img
                        :alt="stars"
                        :title="stars"
                        src="//images-static.trustpilot.com/community/shared/sprite_star.png"
                        class="trustpilot-star-image"
                    />
                </div>
                <div class="trustpilot-star-2">
                    <img
                        :alt="stars"
                        :title="stars"
                        src="//images-static.trustpilot.com/community/shared/sprite_star.png"
                        class="trustpilot-star-image"
                    />
                </div>
                <div class="trustpilot-star-3">
                    <img
                        :alt="stars"
                        :title="stars"
                        src="//images-static.trustpilot.com/community/shared/sprite_star.png"
                        class="trustpilot-star-image"
                    />
                </div>
                <div class="trustpilot-star-4">
                    <img
                        :alt="stars"
                        :title="stars"
                        src="//images-static.trustpilot.com/community/shared/sprite_star.png"
                        class="trustpilot-star-image"
                    />
                </div>
                <div class="trustpilot-star-5">
                    <img
                        :alt="stars"
                        :title="stars"
                        src="//images-static.trustpilot.com/community/shared/sprite_star.png"
                        class="trustpilot-star-image"
                    />
                </div>
            </a>
            <div
                class="trustpilot-aggregate-rating trustpilot-avg-rating-category"
            >
                <div class="trustpilot-rating" itemprop="aggregateRating" itemscope itemtype="https://schema.org/AggregateRating">
                    <div class="d-none d-lg-inline"><span itemprop="ratingValue">{{ rating }}</span> / 5</div>
                    (<span itemprop="reviewCount">{{ reviewCount }}</span>)
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TrustPilotRating",
    props: {
        stars: {
            type: Number,
            required: true
        },
        rating: {
            type: Number,
            required: true
        },
        reviewCount: {
            type: String,
            required: true
        },
        linkToProduct: {
            type: String,
            required: true
        }
    }
};
</script>

<style scoped></style>
